// filepath: d:\Documents\Programming\work\PM.OS.Activation.PlacementManager.UI\src\Views\WorkbookV2\features\useEdit.jsx
import { useCallback, useMemo, useRef } from "react";
import Button, { BUTTON_DISPLAY, BUTTON_SIZE } from "@acadia-ui/button";
import Tooltip, { TOOLTIP_POSITION } from "@acadia-ui/tooltip";
import EditPlacement from "../../Modals/EditPlacement";

export default function useEdit({ config, campaignMetaData, selectedRows, updateCounts, updateMetaData, auditLevelData, auditLevelID, refresh, dataTableApi }) {
	const editPlacementModal = useRef(null);

	const Trigger = useCallback(() => {
		const disabled = dataTableApi?.current?.rowSelectionManager?.tree?.children?.loadedNodes?.filter(({ selectionState }) => selectionState === true)?.length !== 1;
		return (
			<Tooltip key="action-edit" title={"Edit Placement"} position={TOOLTIP_POSITION.BOTTOM_START}>
				<span>
					<Button
						style={{ order: 3 }}
						size={BUTTON_SIZE.SMALL}
						display={BUTTON_DISPLAY.ICON_BORDERED}
						icon="icon-pencil"
						disabled={disabled}
						onClick={() => {
							if (!disabled) {
								editPlacementModal.current?.triggerOpenClose();
							}
						}}
						data-tracking-id-alt="open-edit-placement-modal"
					>
						Edit Placement
					</Button>
				</span>
			</Tooltip>
		);
	}, [selectedRows]);

	const DisplayedComponent = useCallback(() => {
		const row = selectedRows && selectedRows.length === 1 ? selectedRows[0] : undefined;
		return (
			<EditPlacement
				editPlacement={(ref) => {
					editPlacementModal.current = ref;
				}}
				config={config}
				metaData={campaignMetaData}
				placementData={row}
				updateCounts={updateCounts}
				updateMetaData={updateMetaData}
				auditLevelData={auditLevelData}
				auditLevelID={auditLevelID}
				refresh={refresh}
			/>
		);
	}, [config, campaignMetaData, selectedRows, updateCounts, updateMetaData, auditLevelData, auditLevelID, refresh]);

	return useMemo(() => [Trigger, DisplayedComponent], [Trigger, DisplayedComponent]);
}
